var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6 13h30v27H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.333 4.667H27.58C26.6 1.96 24.033 0 21 0s-5.6 1.96-6.58 4.667H4.667A4.68 4.68 0 000 9.333V42a4.68 4.68 0 004.667 4.667h32.666A4.68 4.68 0 0042 42V9.333a4.68 4.68 0 00-4.667-4.666zM21 4.667A2.34 2.34 0 0123.333 7 2.34 2.34 0 0121 9.333 2.34 2.34 0 0118.667 7 2.34 2.34 0 0121 4.667zm-4.667 32.666L7 28l3.29-3.29 6.043 6.02L31.71 15.353 35 18.667 16.333 37.333z",
    fill: "#F9DC66",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIcon);
export default __webpack_public_path__ + "static/media/result-icon.87893848.svg";
export { ForwardRef as ReactComponent };